import React from "react";
import { Col, Container, Row } from "react-bootstrap";

export const Footer = () => {
  return (
    <footer>
      <Container fluid className="px-5">
        <Row>
          <Col className="text-right">
            <a className="text-black" href="/privacy-policy" target="_blank">
              Privacy Policy
            </a>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};
